import { setBackendUrl, setAuthUrl, setDevMode, showPolicyById } from "@securely.id/websdk";
import { loadingSpinner, errorPopup, refreshTooltips } from "./utils.js";
import { prettyAddress } from "./ethereum/utils.js";

async function loadPolicy(policy) {
    const policyDetails = (await showPolicyById(policy)).result;
    $(`#policy-body-${policy}`).html(policyDetails);
}

async function loadPolicies(policy, methods) {
    $('#policies').append(`
        <article class="policy">
            <div class="toggler" id="${policy}-toggler">
                <h4>${policy} <i class="fa-solid fa-angle-down arrow"></i></h4>
                <ul><li>
                    ${methods.join('</li><li>')}
                </li></ul>
            </div>
            <article class="policy-body" id="policy-body-${policy}" style="display: none">${loadingSpinner}</article>
        </article>
    `);
    $(`#${policy}-toggler`).click(function() {
        $(`#policy-body-${policy}`).toggle('slow');
        $(this).find('.arrow').toggleClass('arrow-active');
    });
    loadPolicy(policy);
}

async function buildPolicies(chainid, dappAddress) {
    const policies = (await listPolicies(chainid, dappAddress)).result;
    $('#policies').empty();
    var methodsPerPolicy = {};
    var userPolicy = undefined;
    for (const policy of policies) {
        const isUserPolicy = policy.methodId.split('-').length == 2;
        if (isUserPolicy)
            userPolicy = policy.policyId;
        if (policy.policyId in methodsPerPolicy) {
            if (isUserPolicy)
                methodsPerPolicy[policy.policyId].unshift(policy.methodInfo);
            else
                methodsPerPolicy[policy.policyId].push(policy.methodInfo);
        }
        else
            methodsPerPolicy[policy.policyId] = [policy.methodInfo];
    }
    if (userPolicy !== undefined)
        loadPolicies(userPolicy, methodsPerPolicy[userPolicy]);
    for (const policy of Object.keys(methodsPerPolicy).sort())
        if (policy !== userPolicy)
            loadPolicies(policy, methodsPerPolicy[policy]);
}

async function connectDapp(autoConnect=false) {
    const chainid = $('#chainid-input').val();
    const dappAddress = $('#dapp-address-input').val();
    const prettyDappAddress = prettyAddress(dappAddress);
    if (prettyDappAddress === dappAddress) {
        errorPopup('Invalid Dapp address');
        return;
    }
    $('#dapp-address').html(prettyDappAddress);
    refreshTooltips();
    /* if (!autoConnect)
        successPopup('Dapp connected successfully'); */

    $('#dapp-connected-false').hide();
    $('#dapp-connected-true').show();
    $('.require-dapp-connected-true').show();
    await buildPolicies(chainid, dappAddress);
}

$(document).ready(function() {
    window.setBackendUrl = setBackendUrl;
    window.setAuthUrl = setAuthUrl;
    window.setDevMode = setDevMode;
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has('chainid'))
        $('#chainid-input').val(searchParams.get('chainid'));
    if (searchParams.has('address'))
        $('#dapp-address-input').val(searchParams.get('address'));
    $('#connect-dapp-form').on('submit', function(e) {
        e.preventDefault();
        connectDapp();
    });
    if ($('#chainid-input').val() && $('#dapp-address-input').val())
        connectDapp(true);
});
